import { authorizedAxios } from '../axiosInstances';

class DisclosureService {
  getPreview(disclosure) {
    return authorizedAxios.post(`/api/feature/Disclosure/Preview`, disclosure).then((response) => {
      return response;
    });
  }

  getPreviewUrl(disclosure) {
    return authorizedAxios
      .post(`/api/feature/Disclosure/PreviewUrl`, disclosure)
      .then((response) => {
        return response;
      });
  }

  generate(disclosure) {
    return authorizedAxios.post(`/api/feature/Disclosure/Generate`, disclosure).then((response) => {
      return response;
    });
  }

  sendESignatureViaDocuSign(eDisclosure) {
    return authorizedAxios
      .post(`/api/feature/Disclosure/SendESignatureViaDocuSign`, eDisclosure)
      .then((response) => {
        return response;
      });
  }

  synchronizeDisclosureStatus(fileDataId, docPackageId) {
    return authorizedAxios
      .post(`/api/feature/Disclosure/Synchronize/Status/${fileDataId}/${docPackageId}`, null)
      .then((response) => {
        return response;
      });
  }

  getBusinessDay(afterDays, applicationDate) {
    return authorizedAxios
      .get(`/api/feature/Disclosure/BusinessDay/${afterDays}?applicationDate=${applicationDate}`)
      .then((response) => {
        return response;
      });
  }
}

export default new DisclosureService();
